import type { PageRoute } from '../../page-route';
import { BrigadierList } from './page';

export const route: PageRoute = { path: '/brigadier', access: 'authed', Component: BrigadierList };
